import React, { Component, Fragment } from 'react';
import { Form, Row, Col, Dropdown, Select, Button, Checkbox, Menu, Icon, Input, Table } from 'antd';
import { inject, observer } from 'mobx-react/index';
import { withRouter } from 'react-router-dom';

const Option = Select.Option;

@withRouter
@inject('store')
@observer
class CoinSelectionFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterDropdownVisible: false,
            searchText: '',
            filtered: false
        };
    }

    onInputChange = e => {
        this.setState({ searchText: e.target.value });
    };

    onSearch = () => {
        const { searchText } = this.state;

        this.setState({
            filterDropdownVisible: false,
            filtered: !!searchText
        });
    };

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                values.blacklisted_coins = values.blacklisted_coins.sort((a, b) => {
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                });
                this.props.store.botStore.updateConfig(values);
            }
        });

        let payload = { ...this.state };
        delete payload.strategies;
    }

    render() {
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
        getFieldDecorator('selected_symbols', { initialValue: [] });
        const selectedSymbols = getFieldValue('selected_symbols') || [];
        const autoCoinSelectEnabled = getFieldValue('auto_select_enabled') || false;
        const prices = this.props.store.botStore.marketStore.market;
        const baseCurrency = getFieldValue('base_currency') || 'BTC';

        const data = Object.keys(prices)
            .map(p => prices[p])
            .filter(t => t.symbol.indexOf(baseCurrency.toUpperCase()) >= 2)
            .map(record => {
                const reg = new RegExp(this.state.searchText, 'gi');

                if (!record.symbol) return null;

                const match = record.symbol.match(reg);
                if (!match) return null;

                return { ...record };
            })
            .filter(record => !!record);

        const menu = (
            <Menu
                onClick={({ key }) => {
                    switch (key) {
                        case 'positive_pairs':
                            setFieldsValue({
                                selected_symbols: data
                                    .filter(a => a.percentage >= 0)
                                    .map(o => o.symbol)
                            });
                            break;
                        case 'top_75_volume_base':
                            setFieldsValue({
                                selected_symbols: data
                                    .slice()
                                    .sort((a, b) => b.baseVolume - a.baseVolume)
                                    .slice(0, 75)
                                    .map(o => o.symbol)
                            });
                            break;
                        case 'top_75_volume_quote':
                            setFieldsValue({
                                selected_symbols: data
                                    .slice()
                                    .sort((a, b) => b.quoteVolume - a.quoteVolume)
                                    .slice(0, 75)
                                    .map(o => o.symbol)
                            });
                            break;
                        case 'change':
                            const value = prompt('Select all symbols within %', 2);
                            if (value) {
                                setFieldsValue({
                                    selected_symbols: data
                                        .filter(
                                            a =>
                                                a.percentage >= -Math.abs(parseFloat(value)) &&
                                                a.percentage <= Math.abs(parseFloat(value))
                                        )
                                        .map(o => o.symbol)
                                });
                            }
                            break;
                        default: //noop
                    }
                }}
            >
                <Menu.Item key="positive_pairs">Positive Pairs</Menu.Item>
                <Menu.Item key="top_75_volume_base">Top 75 Volume (Base)</Menu.Item>
                <Menu.Item key="top_75_volume_quote">Top 75 Volume (Quote)</Menu.Item>
                <Menu.Item key="change">Percent Change</Menu.Item>
            </Menu>
        );

        const columns = [
            {
                title: 'Name',
                dataIndex: 'symbol',
                key: 'symbol',
                sorter: (a, b) => {
                    if (a.symbol < b.symbol) return -1;
                    if (a.symbol > b.symbol) return 1;
                    return 0;
                },
                filterDropdownVisible: this.state.filterDropdownVisible,
                onFilterDropdownVisibleChange: visible => {
                    this.setState(
                        {
                            filterDropdownVisible: visible
                        },
                        () => this.state.searchInput && this.state.searchInput.focus()
                    );
                },
                filterDropdown: (
                    <div className="custom-filter-dropdown">
                        <Input
                            ref={ele => (this.searchInput = ele)}
                            placeholder="Search by name"
                            value={this.state.searchText}
                            onChange={this.onInputChange.bind(this)}
                        />
                    </div>
                ),
                render(text, a) {
                    return `${a.symbol}`;
                }
            },
            {
                title: 'Last Price',
                dataIndex: 'last',
                key: 'last',
                sorter: (a, b) => a.last - b.last,
                render: a => a.toFixed(8)
            },
            {
                title: 'Price Change',
                dataIndex: 'change',
                key: 'change',
                render: t => {
                    const val = parseFloat(t);
                    if (val < 0) return <span className="error">{t.toFixed(8)}</span>;
                    if (val > 0) return <span className="success">{t.toFixed(8)}</span>;
                    return <span>{t}</span>;
                },
                sorter: (a, b) => a.change - b.change
            },
            {
                title: 'Price Change %',
                dataIndex: 'percentage',
                key: 'percentage',
                defaultSortOrder: 'descend',
                render: t => {
                    if (!t) return null;
                    const val = t.toFixed(2);
                    if (val < 0) return <span className="error">{t}&#37;</span>;
                    if (val > 0) return <span className="success">{t}&#37;</span>;
                    return <span>{t.toFixed(2)}&#37;</span>;
                },
                sorter: (a, b) => a.percentage - b.percentage
            },
            {
                title: 'Base Volume',
                dataIndex: 'baseVolume',
                key: 'baseVolume',
                sorter: (a, b) => a.baseVolume - b.baseVolume,
                render: a => a.toFixed(8)
            },
            {
                title: 'Quote Volume',
                dataIndex: 'quoteVolume',
                key: 'quoteVolume',
                sorter: (a, b) => a.quoteVolume - b.quoteVolume,
                render: a => a.toFixed(8)
            }
        ];

        return (
            <Fragment>
                <Row gutter={24}>
                    <p>
                        <b>Auto coin selection:</b> Apex will use rankings provided by{' '}
                        <a
                            href="https://www.tradingview.com/crypto-screener/"
                            rel="noopener noreferrer"
                        >
                            Trading View
                        </a>
                    </p>
                    <Col md={3}>
                        <Form.Item>
                            {getFieldDecorator('auto_select_enabled', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox size="large">Enable</Checkbox>)}
                        </Form.Item>
                    </Col>

                    <Col md={4}>
                        <Form.Item label="Timeframe">
                            {getFieldDecorator('auto_select_timeframe', {
                                initialValue: '15'
                            })(
                                <Select>
                                    <Option value={1}>1m</Option>
                                    <Option value={5}>5m</Option>
                                    <Option value={15}>15m</Option>
                                    <Option value={60}>1h</Option>
                                    <Option value={240}>4h</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={4}>
                        <Form.Item label="Minimum Ranking">
                            {getFieldDecorator('auto_select_minimum_rank', {
                                initialValue: 0
                            })(
                                <Select>
                                    <Option value={0}>Buy</Option>
                                    <Option value={0.5}>Strong Buy</Option>
                                    <Option value={-0.5}>Sell</Option>
                                    <Option value={-1}>Strong Sell</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <div md={24}>
                    <Form.Item label="Blacklisted Coins">
                        {getFieldDecorator('blacklisted_coins', {
                            initialValue: []
                        })(
                            <Select
                                mode="multiple"
                                size="large"
                                style={{ width: '100%' }}
                                showSearch={false}
                                filterOption={(inputValue, option) => {
                                    return (
                                        option.key
                                            .toLowerCase()
                                            .indexOf(inputValue.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {data
                                    .sort((a, b) => {
                                        if (a.symbol < b.symbol) return -1;
                                        if (a.symbol > b.symbol) return 1;
                                        return 0;
                                    })
                                    .map(item => {
                                        return (
                                            <Option key={item.name} value={item.name}>
                                                {item.symbol}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </div>

                <div style={{ marginBottom: 10 }}>
                    <Button
                        disabled={autoCoinSelectEnabled}
                        type="primary"
                        onClick={() => {
                            setFieldsValue({ selected_symbols: data.map(o => o.symbol) });
                        }}
                    >
                        Select All
                    </Button>
                    &nbsp;&nbsp;
                    <Dropdown disabled={autoCoinSelectEnabled} overlay={menu}>
                        <Button type="primary">
                            Pre Selection <Icon type="down" />
                        </Button>
                    </Dropdown>
                    &nbsp;&nbsp;
                    <Button
                        disabled={autoCoinSelectEnabled}
                        type="danger"
                        onClick={() => {
                            setFieldsValue({ selected_symbols: [] });
                        }}
                    >
                        Clear Selection
                    </Button>
                </div>

                <Table
                    size="small"
                    bordered
                    dataSource={data}
                    rowKey="symbol"
                    columns={columns}
                    scroll={{ x: 1000 }}
                    pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '25', '50', '100']
                    }}
                    rowSelection={{
                        getCheckboxProps: record => ({
                            disabled: autoCoinSelectEnabled
                        }),
                        onChange: (selectedRowKeys, selectedRows) => {
                            setFieldsValue({ selected_symbols: selectedRowKeys });
                        },
                        selectedRowKeys: selectedSymbols
                    }}
                />

                <Button
                    className={'btn-cta'}
                    onClick={this.handleSubmit.bind(this)}
                    type="primary"
                    size="large"
                >
                    Save
                </Button>
            </Fragment>
        );
    }
}

export const CoinSelectionForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            if (k === 'api_key' || k === 'api_secret') return;
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(CoinSelectionFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/CoinSelectionForm.js